import { Row, Space, Typography } from 'antd';
import { FilterField } from './FilterField'

const { Text } = Typography;

export const FilterGroupField = ({
  items,
  modifiedFilters,
  compact,
  ...filterFieldProps
}) => {
  const renderLabel = (label) => (
    label
      ? <Text type='secondary' style={{ fontSize: '0.9em' }}>{label}</Text>
      : null
  );

  const renderedFields = (<>
    {items.map(({ key, name, label, component, ...restItemProps }, index) => (
      <FilterField
        key={key ?? name ?? (typeof label === 'string' ? label : `item${index}`)}
        name={name}
        label={renderLabel(label)}
        col={{ flex: '1' }}
        modifiedFilters={modifiedFilters}
        layout='vertical'
        {...restItemProps}
        labelCol={{
          ...restItemProps.labelCol,
          style: {
            padding: 0,
            lineHeight: 1,
            ...restItemProps.labelCol?.style
          },
        }}
      >
        {component}
      </FilterField>
    ))}
  </>)

  const hasAnyLabel = items.some(({ label }) => !!label);

  return (
    <FilterField
      {...filterFieldProps}
      labelCol={{
        ...filterFieldProps.labelCol,
        style: {
          paddingBottom: hasAnyLabel ? 4 : undefined, // Aplica un padding inferior reducido al label principal si existe al menos un label en los campos secundarios
          ...filterFieldProps.labelCol?.style
        },
      }}
    >
      {compact ? (
        <Space.Compact block>
          {renderedFields}
        </Space.Compact>
      ) : (
        <Row gutter={8} align='bottom'>
          {renderedFields}
        </Row>
      )}
    </FilterField>
  );
};